import { Calendar } from 'lucide-react'
import { Button } from '../ui/button'
import { Input } from '../ui/input'

interface RegulatoryDateFiltersProps {
  startDate: string
  endDate: string
  onStartDateChange: (value: string) => void
  onEndDateChange: (value: string) => void
}

export function RegulatoryDateFilters({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}: RegulatoryDateFiltersProps) {
  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <div className="flex flex-col items-end gap-4 md:flex-row">

        <div className="flex-1 space-y-2">
          <label className="text-sm font-medium text-card-foreground">
            Fecha inicio:
          </label>

          <Input
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            className="border-border bg-card text-card-foreground"
          />
        </div>

        <div className="flex-1 space-y-2">
          <label className="text-sm font-medium text-card-foreground">
            Fecha fin:
          </label>

          <Input
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            className="border-border bg-card text-card-foreground"
          />
        </div>

        <Button>
          <Calendar className="mr-2 h-4 w-4" />
          Aplicar Filtro
        </Button>

      </div>
    </div>
  )
}